import DashboardIcon from "@mui/icons-material/Dashboard";
import ScienceIcon from "@mui/icons-material/Science";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import SettingsIcon from "@mui/icons-material/Settings";
import BallotIcon from "@mui/icons-material/Ballot";
import BuildIcon from "@mui/icons-material/Build";
import AddHomeWorkIcon from "@mui/icons-material/AddHomeWork";
import BusinessIcon from "@mui/icons-material/Business";
import DescriptionIcon from "@mui/icons-material/Description";
import RuleIcon from "@mui/icons-material/Rule";
import BarChartIcon from "@mui/icons-material/BarChart";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import PsychologyIcon from "@mui/icons-material/Psychology";
import TodayIcon from "@mui/icons-material/Today";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import ThermostatIcon from "@mui/icons-material/Thermostat";
import ContentCutIcon from "@mui/icons-material/ContentCut";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import BiotechIcon from "@mui/icons-material/Biotech";
import SpeedIcon from "@mui/icons-material/Speed";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import LayersIcon from "@mui/icons-material/Layers";
import TerrainIcon from "@mui/icons-material/Terrain";
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import AddRoadIcon from "@mui/icons-material/AddRoad";
import EngineeringIcon from "@mui/icons-material/Engineering";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ImageIcon from "@mui/icons-material/Image";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";

export const SIDEBAR_ITEMS = {
  main: [
    {
      id: "propostaComercial",
      label: "Proposta comercial",
      path: "/app/proposta-comercial",
      icon: RequestQuoteIcon,
      tiposPermitidos: ["admin"],
      somenteAdminPrincipal: true,
    },
    {
      id: "locacaoEquipamentos",
      label: "Locação de equipamentos",
      path: "/app/locacao-equipamentos",
      icon: RequestQuoteIcon,
      tiposPermitidos: ["admin"],
      somenteAdminPrincipal: true,
    },
    {
      id: "medicoes",
      label: "Medições",
      path: "/app/medicoes",
      icon: RequestQuoteIcon,
      tiposPermitidos: ["admin"],
      somenteAdminPrincipal: true,
    },
    {
      id: "dosagem",
      label: "Dosagem",
      path: "/app/cadastro-dosagem",
      icon: ScienceIcon,
      tiposPermitidos: ["admin", "colaborador"],
      destaque: true,
    },
    {
      id: "gestaoMudancas",
      label: "Gestão de mudanças",
      path: "/app/gestao-mudancas",
      icon: RuleIcon,
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "analiseCriticaDirecao",
      label: "Análise Crítica da Direção",
      path: "/app/analise-critica-direcao",
      icon: DescriptionIcon,
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "planejamentoEstrategico",
      label: "Planejamento Estratégico",
      path: "/app/planejamento-estrategico",
      icon: DescriptionIcon,
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "manualQualidade",
      label: "Manual da Qualidade",
      path: "/app/manual-qualidade",
      icon: DescriptionIcon,
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "guiasDosagem",
      label: "Guias de Dosagem",
      path: "/app/guias-dosagem",
      icon: AssignmentTurnedInIcon,
      tiposPermitidos: ["admin", "colaborador"],
    },
    {
      id: "relatoriosVisitaTecnica",
      label: "Relatórios visita técnica",
      path: "/app/relatorios-visita-tecnica",
      icon: EngineeringIcon,
      tiposPermitidos: ["admin"],
      somenteAdminPrincipal: true,
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: DashboardIcon,
      path: "/dashboard",
    },
    
  {
  id: "ensaios",
  label: "Ensaios",
  icon: ScienceIcon,
  children: [
    {
      id: "agendaRuptura",
      label: "Agenda de Ruptura",
      path: "/app/agendamoldagem",
      icon: CalendarMonthIcon,
      categoria: "concreto"
    },
    {
      id: "raa",
      label: "Ensaio RAA",
      path: "/app/ensaio-raa",
      icon: BiotechIcon,
      categoria: "concreto"
    },
    {
      id: "extracoesTestemunhos",
      label: "Cadastrar Extrações",
      path: "/app/extracoes-testemunhos",
      icon: ContentCutIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "esclerometria",
      label: "Esclerometria",
      path: "/app/esclerometria",
      icon: SpeedIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "resistenciaTracao",
      label: "Resistência à Tração",
      path: "/app/resistencia-tracao",
      icon: ScienceIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "ensaioArgamassa",
      label: "Argamassa - Tração e Compressão",
      path: "/app/ensaio-argamassa",
      icon: ScienceIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "moduloElasticidade",
      label: "Modulo de Elasticidade",
      subtitulo: "Método de frequências naturais",
      path: "/app/modulo-elasticidade",
      icon: SpeedIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "rupturaPaver",
      label: "Ruptura de Paver",
      path: "/app/ruptura-paver",
      icon: GridViewIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "rupturaBlocoCeramico",
      label: "Ruptura Bloco Cerâmico",
      path: "/app/ruptura-bloco-ceramico",
      icon: ViewInArIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "rupturaBlocoConcreto",
      label: "Ruptura Bloco de Concreto",
      path: "/app/ruptura-bloco-concreto",
      icon: ViewInArIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "caracterizacaoAgregados",
      label: "Cadastrar Caracterização",
      path: "/app/cadastro-caracterizacao",
      icon: LayersIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "cimentoConsistenciaPega",
      label: "Consist. Cimento/Pega",
      path: "/app/cimento-consistencia-pega",
      icon: ScienceIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador", "cliente"]
    },
    {
      id: "compactacao",
      label: "Ensaio de Compactação",
      path: "/app/ensaio-compactacao",
      icon: TerrainIcon,
      categoria: "solos",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "soloCimento",
      label: "Ensaio Solo-Cimento",
      path: "/app/ensaio-solo-cimento",
      icon: ViewInArIcon,
      categoria: "concreto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "densidadeInSitu",
      label: "Densidade IN SITU",
      path: "/app/densidade-in-situ",
      icon: WaterDropIcon,
      categoria: "solos",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "caracterizacaoAsfalto",
      label: "Caracterização Asfalto",
      path: "/app/caracterizacao-asfalto",
      icon: AddRoadIcon,
      categoria: "asfalto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "tracoCbuq",
      label: "Traço CBUQ",
      path: "/app/traco-cbuq",
      icon: AddRoadIcon,
      categoria: "asfalto",
      tiposPermitidos: ["admin", "colaborador"]
    },
    {
      id: "adesividadeLiganteBetuminoso",
      label: "Adesividade ao Ligante",
      path: "/app/adesividade-ligante-betuminoso",
      icon: AddRoadIcon,
      categoria: "asfalto",
      tiposPermitidos: ["admin", "colaborador"]
    }
  ]
},


   {
  id: "aprovacoes",
  label: "Aprovações",
  icon: CheckCircleIcon,
  path: "/app/aprovacoes",
  aprovacao: true,
  tiposPermitidos: ["admin"],
},

{
  id: "calibracao_prensa",
  label: "Calibração de Prensa",
  icon: PrecisionManufacturingIcon,
  children: [
    {
      id: "calibracao_prensa_concreto",
      label: "Prensa CONCRETO",
      path: "/app/calibracao-prensa",
      icon: PrecisionManufacturingIcon,
      tiposPermitidos: ["admin"]
    },
    {
      id: "calibracao_prensa_externa",
      label: "Prensa EXTERNA",
      path: "/app/calibracao-prensa-externa",
      icon: PrecisionManufacturingIcon,
      tiposPermitidos: ["admin"]
    },
    {
      id: "calibracao_prensa_solos",
      label: "Prensa SOLOS",
      path: "/app/calibracao-prensa-solos",
      icon: TerrainIcon,
      tiposPermitidos: ["admin"]
    }
  ]
},


    {
      id: "config",
      label: "Configurações",
      icon: SettingsIcon,
      tiposPermitidos: ["admin"],
      somenteAdminPrincipal: true,
      children: [
        {
          id: "exportacaoDados",
          label: "Exportação de Dados",
          path: "/app/configuracoes/exportacao-dados",
          icon: GridOnOutlinedIcon,
          tiposPermitidos: ["admin"],
          somenteAdminPrincipal: true,
        },
        {
          id: "logoRelatorios",
          label: "Logo do Sistema e Relatórios",
          path: "/app/configuracoes/logo-relatorios",
          icon: ImageIcon,
          tiposPermitidos: ["admin"],
          somenteAdminPrincipal: true,
        },
        {
          id: "tabelaCilindrosCompactacao",
          label: "Tabela de Cilindros",
          path: "/app/configuracoes/tabela-cilindros",
          icon: ViewColumnIcon,
          tiposPermitidos: ["admin"],
          somenteAdminPrincipal: true,
        },
        {
          id: "tabelaCapsulasCompactacao",
          label: "Tabela de Cápsulas",
          path: "/app/configuracoes/tabela-capsulas",
          icon: Inventory2Icon,
          tiposPermitidos: ["admin"],
          somenteAdminPrincipal: true,
        },
        {
          id: "faixasDnitCompactacao",
          label: "Faixas DNIT - Solos",
          path: "/app/configuracoes/faixas-dnit",
          icon: ViewColumnIcon,
          tiposPermitidos: ["admin"],
          somenteAdminPrincipal: true,
        },
        {
          id: "faixasDnitAsfalto",
          label: "Faixas DNIT - Asfalto CBUQ",
          path: "/app/configuracoes/faixas-dnit-asfalto",
          icon: ViewColumnIcon,
          tiposPermitidos: ["admin"],
          somenteAdminPrincipal: true,
        }
      ],
    },
  ],

  cadastrar: [
    {
        id: "rupturasHoje",
        label: "Rupturas do Dia",
        path: "/app/rupturas-hoje",
        icon: TodayIcon
      },
    {
      id: "materiais",
      label: "Materiais",
      icon: BallotIcon,
      path: "/app/cadastromateriais",
    },
    {
      id: "equipamentos",
      label: "Equipamentos",
      icon: BuildIcon,
      path: "/app/cadastro-equipamentos",
    },
    {
      id: "obras",
      label: "Obras",
      icon: AddHomeWorkIcon,
      path: "/app/cadastroobras",
    },
    {
      id: "concreteiras",
      label: "Concreteiras",
      icon: BusinessIcon,
      path: "/app/cadastro-concreteiras",
    },
    {
      id: "qualificacaoFornecedores",
      label: "Qualificação de Fornecedores",
      icon: AssignmentTurnedInIcon,
      path: "/app/qualificacao-fornecedores",
      tiposPermitidos: ["admin", "colaborador"],
    },
    {
      id: "planoComunicacao",
      label: "Plano de Comunicação",
      icon: DescriptionIcon,
      path: "/app/plano-comunicacao",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "objetivosQualidade",
      label: "Objetivos da Qualidade",
      icon: DescriptionIcon,
      path: "/app/objetivos-qualidade",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "matrizRiscos",
      label: "Matriz de Riscos",
      aliases: ["RQ 1.6", "riscos", "ameaças", "mitigação"],
      icon: DescriptionIcon,
      path: "/app/matriz-riscos",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "requisitosLegais",
      label: "Requisitos Legais",
      aliases: ["RQ 1.8", "normas", "regulamentos", "legislação"],
      icon: DescriptionIcon,
      path: "/app/requisitos-legais",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "planejamentoRecursos",
      label: "Planejamento de Recursos",
      aliases: ["RQ 1.13", "recursos", "planejamento anual"],
      icon: DescriptionIcon,
      path: "/app/planejamento-recursos",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "controleResiduos",
      label: "Volume e Controle de Resíduos",
      aliases: ["RQ 10.2", "resíduos", "destinação", "meio ambiente"],
      icon: DescriptionIcon,
      path: "/app/controle-residuos",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "programaTreinamentos",
      label: "Programa de Treinamentos",
      icon: AssignmentTurnedInIcon,
      path: "/app/programa-treinamentos",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "listasPresencaTreinamentos",
      label: "Lista de Presença em Treinamentos",
      aliases: ["RQ 1.12", "lista assinada", "presença", "treinamento", "instrutor"],
      icon: AssignmentTurnedInIcon,
      path: "/app/listas-presenca-treinamentos",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "quadroCompetencias",
      label: "Quadro de Competências",
      icon: AssignmentTurnedInIcon,
      path: "/app/quadro-competencias",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "verificacaoCompetencias",
      label: "Verificação de Competências e Habilidades",
      icon: AssignmentTurnedInIcon,
      path: "/app/verificacao-competencias",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "controleManutencaoEquipamentos",
      label: "Controle de Manutenção de Equipamentos",
      icon: BuildIcon,
      path: "/app/controle-manutencao-equipamentos",
      tiposPermitidos: ["admin", "qualidade"],
    },
    {
      id: "caixinhaEmpresa",
      label: "Caixinha da Empresa",
      icon: AccountBalanceWalletIcon,
      path: "/app/caixinha-empresa",
      tiposPermitidos: ["admin", "colaborador"],
    },
    {
      id: "dp",
      label: "Departamento Pessoal",
      icon: BusinessIcon,
      path: "/app/departamento-pessoal",
    },
    {
      id: "usuarios",
      label: "Usuários",
      icon: BusinessIcon,
      path: "/app/cadastrousuarios",
    },
    {
      id: "laudos",
      label: "Laudos",
      icon: DescriptionIcon,
      path: "/app/cadastrarlaudos",
    },
    {
      id: "controle_temperatura_tanque_cura",
      label: "Tanque de Cura",
      icon: ThermostatIcon,
      path: "/app/controle-temperatura-tanque-cura",
    },
  ],

  admin: [
    {
      id: "admin_sgq",
      label: "Admin SGQ",
      icon: RuleIcon,
      path: "/admin-sgq",
      tiposPermitidos: ["admin"],
    },
    {
      id: "lista_mestra",
      label: "Lista Mestra",
      icon: DescriptionIcon,
      path: "/lista-mestra",
      tiposPermitidos: ["admin"],
    },
    {
      id: "admin_kpis",
      label: "Admin KPIs",
      icon: BarChartIcon,
      path: "/admin/kpis",
      tiposPermitidos: ["admin"],
    },
    {
      id: "kpis_respostas",
      label: "Pesquisas Respondidas",
      icon: AssignmentTurnedInIcon,
      path: "/admin/kpis/respostas",
      tiposPermitidos: ["admin"],
    },
    {
      id: "cadastro_psicossocial",
      label: "Cadastro Psicossocial",
      icon: PsychologyIcon,
      path: "/admin/psicossocial/cadastro",
      tiposPermitidos: ["admin"],
    },
  ],
};

